import React from 'react';
import './style.scss';
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem";

export default function OrderDeparture(props) {
    if (!props.placesOfDeparture)
        return null;

    const onChange = (newDeparture) => {
        if (props.onChange)
            props.onChange(newDeparture);
    };

    return (
        <div className="order-departure">
            {
                props.orderSource === "SHIPIT_WEB" && !props.disabled && !props.isRedirected ?
                    <Select
                        className="order-departure-select"
                        value={props.departure}
                        onChange={(event) => onChange(event.target.value)}>
                        {
                            props.placesOfDeparture.map(placeOfDeparture => {
                                return (<MenuItem key={`place-of-departure-${placeOfDeparture.name}`}
                                                  value={placeOfDeparture.name}>{placeOfDeparture?.title ?? placeOfDeparture.name}</MenuItem>);
                            })
                        }
                    </Select>
                    :
                    <div>{props.placesOfDeparture.find(placeOfDeparture => placeOfDeparture.name === props.departure)?.title ?? props.departure}</div>
            }
        </div>
    );
}